export default "../3b27958872e2da26fcf62dd993aaceef.png";